export default {
	LESSON: 'lesson',
	GOOGLE_SLIDE: 'google_slide',
	INTERACTIVE_VIDEO: 'interactive_video',
	FOLDER: 'folder',
}
